import React, { useState } from 'react';
import { XI_MASCOT_HOME_SRC } from './XiMascot';

/**
 * XiChatMascot — the chatbot empty-state mascot.
 *
 * The chatbot intentionally uses only the static artwork so no animated 3D
 * layer can overlap the welcome content or input area.
 */
export default function XiChatMascot({ className = '' }) {
  const [failed, setFailed] = useState(false);

  return (
    <div className={`xi-chat-mascot ${className}`.trim()}>
      <span className="xi-chat-mascot__halo" aria-hidden="true" />

      {!failed ? (
        <img
          className="xi-chat-mascot__img"
          src={XI_MASCOT_HOME_SRC}
          alt="Xi, your wellbeing companion"
          draggable={false}
          decoding="async"
          onError={() => setFailed(true)}
        />
      ) : (
        <img
          className="xi-chat-mascot__img"
          src="/xi/mascot-idle.png"
          alt="Xi, your wellbeing companion"
          draggable={false}
        />
      )}
    </div>
  );
}
